<script setup>
import { ref } from 'vue'
const emit = defineEmits(['clicked'])

const props = defineProps({
  device: {
    type: Object,
    required: true,
  },
  class: {
    type: String,
    default: '',
  },
  src: {
    type: String,
    default: '',
    required: true,
  },
  isSelectedDevice: {
    type: Boolean,
    required: true,
  },
})

const clicked = ref(false)
const emitted = ref(false)

const rightClickedImage = (device, event) => {
  if (!props.isSelectedDevice) return

  emit('clicked', {
    event: 'click',
    data: getData(device, event, 'right_click'),
  })
}

const clickedImage = (device, event) => {
  if (!props.isSelectedDevice) return

  setTimeout(() => {
    if (clicked.value) {
      emit('clicked', {
        event: 'click',
        data: getData(device, event, 'double_click'),
      })
      emitted.value = true
    } else {
      clicked.value = true

      setTimeout(() => {
        if (!emitted.value) {
          emit('clicked', {
            event: 'click',
            data: getData(device, event, 'click'),
          })
        }
        clicked.value = false
        emitted.value = false
      }, 300)
    }
  }, 300)
}

const getData = (device, event, type) => {
  let rect = event.target.getBoundingClientRect()

  let dataDiv = {
    top: rect.top + window.scrollY,
    left: rect.left + window.scrollX,
  }

  let clickX = event.pageX - dataDiv.left
  let clickY = event.pageY - dataDiv.top

  let percentXImg = (clickX * 100) / event.target.width
  let percentYImg = (clickY * 100) / event.target.height

  return {
    x: percentXImg,
    y: percentYImg,
    id: device.external_identifier ?? 'Testing',
    node_name: device.node_name,
    type,
  }
}
</script>

<template>
  <img
    :src="src"
    :alt="device.entity_id"
    :class="`inline-block ${props.class}`"
    :title="device.latest_screenshot"
    @click.stop="clickedImage(device, $event)"
    @contextmenu.prevent="rightClickedImage(device, $event)"
    @error="$event.target.src='/images/testbeeld.png'"
  />
</template>
